import React, { useState } from "react"
import { Link } from "gatsby"

import * as headerStyles from"./header.module.scss"

import Search from "./search"
import ReactGA from "react-ga"

const logger = function (linkName, headerLink) {
  ReactGA.event({
    category: "Header Menu Clicks",
    action: `User clicked on ${linkName}`,
    label: `${headerLink}`,
  })
}

const signUplogger = function () {
  ReactGA.event({
    category: "Signup",
    action: "User clicked on Free signup button",
    label: "Signup",
  })
}

const demologger = function () {
  ReactGA.event({
    category: "Live Demo",
    action: "User clicked on Live Demo button",
    label: "Live Demo",
  })
}

const Header = ({ menuLinks, searchIndex }) => {
  const [shouldClose, close] = useState(false)
  return (
    <>
      {false && !shouldClose ? (
        <div className={headerStyles.topStrip}>
          <p>
            <a
              href={"https://www.AuntyKnows.com/resources/#live-product-demo"}
              key={"live_demo"}
              className="ga_event"
              rel="noopener noreferrer"
              onClick={() => demologger()}
            >
              {"Join us on the demo"}
            </a>
            , while our product experts provide a detailed walkthrough of our
            enterprise platform.
          </p>
          <button
            onClick={() => close(true)}
            className={headerStyles.closeIcon}
          ></button>
        </div>
      ) : null}

      <div className={headerStyles.header}>
        <Link className={headerStyles.logo} to="/">
		  <img src={`/assets/images/logo-white.png`} title={"logo"} alt={"logo"} />
        </Link>
        <input type="checkbox" id={headerStyles.navCheck} />
        <div className={headerStyles.navBtn}>
          <label htmlFor="navCheck">
            <span></span>
            <span></span>
            <span></span>
          </label>
        </div>
        <div className={headerStyles.menuLinks}>
			{/*<nav className={headerStyles.menuLinksinner}>
            <ul>
              {menuLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.slug}
                    key={index}
                    className="ga_event"
                    rel="noopener noreferrer"
                    onClick={() => logger(link.name, link.slug)}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
			</nav>*/}
          <div className={headerStyles.navRightSide}>
            <div className={headerStyles.freeSignup}>
              <a
                className={`${headerStyles.navcta} btn-primary  ga_event }`}
                href={`/contact-us/`}
                rel="noopener noreferrer"
                onClick={signUplogger}
              >
                {"Contact Us"}
              </a>
            </div>
            <Search searchIndex={searchIndex} />
          </div>
        </div>
        <div className={headerStyles.backdrop} />
      </div>
    </>
  )
}

export default Header
